import React from "react";
import { useTranslation } from "react-i18next";
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import clsx from "clsx";
import Grid from "@material-ui/core/Grid";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableContainer from '@material-ui/core/TableContainer';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import ResponsiveWrapper from 'components/charts/ResponsiveWrapper';
import D3Tooltip from "../D3Charts/D3Tooltip";

const useStyles = makeStyles((theme) => ({
    root: {
        // border: `2px solid ${theme.palette.white}`,
    },
    table:
    {
        width: '100%',
        borderCollapse: 'collapse',
        backgroundColor: theme.palette?.importtable.navyBlue,
    },

    importSubText1:
    {
        backgroundColor: theme.palette?.importtable.lightGreen,
        textAlign: 'center',
        padding: theme.spacing(0.625),
        color: theme.palette?.black
    },
    importSubText2:
    {
        backgroundColor: theme.palette?.importtable.lightPaleGrey,
        textAlign: 'center',
        padding: theme.spacing(0.625),
        color: theme.palette?.black
    },
    importSubTextValue1:
    {
        backgroundColor: theme.palette?.importtable.pastelRed,
        color: theme.palette?.black,
        marginBottom: theme.spacing(2)
    },
    importSubTextValue2:
    {
        backgroundColor: theme.palette?.importtable.blanchedAlmond,
        color: theme.palette?.black
    },
    destVal:
    {
        paddingTop: theme.spacing(2)
    },
    textAlign:
    {
        textAlign: 'center',
        paddingBottom: theme.spacing(2),
        marginLeft: theme.spacing(0.5)
    },
    textAlignMargin:
    {
        marginLeft: theme.spacing(0.375)
    },
    tableRowBorders: {
        borderTop: `2px solid ${theme.palette.white}`,
        borderBottom: `2px solid ${theme.palette.white}`,
    },
    displayProps: {
        display: "flex"
    },
    marginAlign: {
        marginLeft: theme.spacing(0.25),
        marginRight: theme.spacing(0.25),
        paddingLeft: theme.spacing(0.375),
        paddingRight: theme.spacing(0.25),
    },
    withoutImportBorders: {
        paddingLeft: theme.spacing(0.5),
        borderLeft: `2px solid ${theme.palette.white}`,
        marginLeft: theme.spacing(0.375),
    },
    tablePadding:
    {
        paddingTop: theme.spacing(2.125),
        paddingBottom: theme.spacing(2.25)
    },
    withoutImportAlignment:
    {
        paddingBottom: theme.spacing(2),
    },
    withoutImportMarginAlignment:
    {
        marginTop: theme.spacing(2)
    },
    valueAlign:
    {
        "@media (max-width: 539px)": {
            marginBottom: theme.spacing(2.25)
        }
    },
    link: {
        cursor: 'pointer',
        textDecoration: 'underline',
        letterSpacing: '1px',
        padding: theme.spacing(.4),
        '&:hover': {
            color: theme.palette.link.hover
        }
    },
}));

const ShipmentContainerImportKPI = (props) => {
    const {
        tableContainer,
        title1,
        title2,
        title3,
        title4,
        title5,
        height,
        themeType,
        data,
        loading,
        setDetails,
        valueType,
        ...rest
    } = props;

    const classes = useStyles();
    const { t } = useTranslation();
    const lang = localStorage.getItem('i18nextLng');

    const svgBoundaries = {
        width: rest.parentWidth,
        height: height
    }
    const centerPos = [svgBoundaries.width / 2, svgBoundaries.height / 2];

    const NoDataText = () => {
        const text = loading ? "loading" : "no_data_found"
        return (
            <svg width={svgBoundaries.width} height={svgBoundaries.height}>
                <g transform={`translate(${centerPos})`} data-testid={"no-data-found"} >
                    <text textAnchor="middle" data-testid="noData"
                        fill={themeType === "dark" ? "white" : "black"}>
                        {t(text)}
                    </text>
                </g>
            </svg>
        )
    }

    const isHyperlink = typeof setDetails === "function";

    return (
        (!(data[0]?.totalShipments) || loading) ? <NoDataText /> :
            <div className={classes.root} data-testid="shipmentContainers">
                <Box className={clsx(classes.textAlign, classes.tablePadding)}>
                    <D3Tooltip placement="top"
                        title={<div
                            className={clsx(isHyperlink ? classes.link : {})}
                            onClick={() => { isHyperlink && setDetails({ ...rest, valueType, stateKey: 'TOTAL' }) }}
                        >
                            {`${tableContainer}: ${data[0]?.totalCntrs}`}
                        </div>}>
                        <Typography component='p'>
                            <Typography variant="body1">{data[0]?.totalCntrs}</Typography>
                            <Typography variant="body1">{tableContainer}</Typography>
                        </Typography>
                    </D3Tooltip>
                </Box>
                <TableContainer component={Paper} >
                    <Table className={classes.table}>
                        <TableBody>
                            {data.map(item => (
                                <TableRow className={classes.tableRowBorders}>
                                    <Box className={clsx(classes.displayProps, classes.marginAlign)}>

                                        <Grid item xs={6} sm={6} md={6} lg={6} xl={6} className={classes.tablePadding}>
                                            <Box className={classes.displayProps}>
                                                <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
                                                    <Typography variant="body1" className={lang === 'en' ? clsx(classes.textAlign, classes.valueAlign) : clsx(classes.textAlign, classes.textAlignMargin)}>{t(title1)}</Typography>
                                                    < D3Tooltip placement={"top"} color={"#d9ead3"}
                                                        title={<div
                                                            className={clsx(isHyperlink ? classes.link : {})}
                                                            onClick={() => { isHyperlink && setDetails({ ...item, stateKey: title1, valueType }) }}
                                                        >
                                                            {t(title1)} : {item.cntrsWithID}
                                                        </div>}>
                                                        <Typography variant="body1" data-testid={`${title1}-value`} className={classes.importSubText1}>{item.cntrsWithID}</Typography>
                                                    </D3Tooltip>
                                                </Grid>
                                                <Grid item xs={6} sm={6} md={6} lg={6} xl={6} >
                                                    <Typography variant="body1" className={lang === 'en' ? classes.textAlign : clsx(classes.textAlign, classes.textAlignMargin)} >{t(title2)}</Typography>
                                                    < D3Tooltip placement={"top"} color={"#87bfdf"}
                                                        title={<div
                                                            className={clsx(isHyperlink ? classes.link : {})}
                                                            onClick={() => { isHyperlink && setDetails({ ...item, stateKey: title2, valueType }) }}
                                                        >
                                                            {t(title2)} : {item.cntrsWithoutID}
                                                        </div>}>
                                                        <Typography variant="body1" data-testid={`${title2}-value`} className={classes.importSubText2} >{item.cntrsWithoutID}</Typography>
                                                    </D3Tooltip>
                                                </Grid>
                                            </Box>
                                        </Grid>

                                        <Grid item xs={6} sm={6} md={6} lg={6} xl={6} className={clsx(classes.withoutImportBorders, classes.tablePadding)}>
                                            <Typography variant="body1">{t(title3)}</Typography>
                                            <Grid className={clsx(classes.displayProps)}>
                                                <Grid item xs={8} sm={8} md={8} lg={8} xl={8} className={classes.withoutImportMarginAlignment}>
                                                    <Typography variant="body1" className={classes.withoutImportAlignment}>{t(title4)}:</Typography>
                                                    <Typography variant="body1" className={classes.withoutImportAlignment}>{t(title5)}:</Typography>
                                                </Grid>

                                                <Grid item xs={4} sm={4} md={4} lg={4} xl={4} className={classes.destVal}>
                                                    < D3Tooltip placement={"top"} color={"#f4cccc"}
                                                        title={<div
                                                            className={clsx(isHyperlink ? classes.link : {})}
                                                            onClick={() => { isHyperlink && setDetails({ ...item, stateKey: title4, valueType }) }}
                                                        >
                                                            {t(title4)} : {item.cntrsWithoutIDAtDest}
                                                        </div>}>
                                                        <Typography variant="body1" data-testid={`${title4}-value`} className={classes.importSubTextValue1}>{item.cntrsWithoutIDAtDest}</Typography>
                                                    </D3Tooltip>
                                                    < D3Tooltip placement={"top"} color={"#fff2cc"}
                                                        title={<div
                                                            className={clsx(isHyperlink ? classes.link : {})}
                                                            onClick={() => { isHyperlink && setDetails({ ...item, stateKey: title5, valueType }) }}
                                                        >
                                                            {t(title5)} : {item.cntrWithoutIDPendingForArrival}
                                                        </div>}>
                                                        <Typography variant="body1" data-testid={`${title5}-value`} className={classes.importSubTextValue2}>{item.cntrWithoutIDPendingForArrival}</Typography>
                                                    </D3Tooltip>
                                                </Grid>

                                            </Grid>
                                        </Grid>

                                    </Box>

                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>

            </div>

    );

}

export default ResponsiveWrapper(ShipmentContainerImportKPI);